export default __webpack_public_path__ + "static/media/popper.ea4548df.svg";